import React from 'react';
import { View, Text, type StyleProp, type TextStyle, type ViewStyle } from 'react-native';

export type CalendarWeekdayStripProps = {
  labels: string[];
  rowStyle: StyleProp<ViewStyle>;
  cellStyle: StyleProp<ViewStyle>;
  textStyle: StyleProp<TextStyle>;
};

/** Shared Sun–Sat header row for calendar modals (parent supplies LTR row style). */
export function CalendarWeekdayStrip({ labels, rowStyle, cellStyle, textStyle }: CalendarWeekdayStripProps) {
  return (
    <View style={rowStyle}>
      {labels.map(day_name => (
        <View key={day_name} style={cellStyle}>
          <Text style={textStyle}>{day_name}</Text>
        </View>
      ))}
    </View>
  );
}
